/* eslint-disable */
import { Component } from 'react';

import { COLUMNS, keysFunction } from './keys';
import List from '../../components/List';
import DataTable from '../../components/Datatable';
import { scrollForTable } from '../../components/Datatable/utils';
import { colors } from '../../lib/colors';

class Summary extends Component {
    constructor() {
        super();

        this.urlParams = new URLSearchParams(window.location.search);

        this.is_one = this.urlParams.get('is_one');
        this.entity_ids = this.urlParams.get('entity_ids');
        this.country = this.urlParams.get('country');
    }

    searchFunction(data) {
        return data;
    }

    onCloseModal() {
        this.setState({
            isOpen: false,
            image: null,
        });
    }

    onOpen(image) {
        this.setState({
            isOpen: true,
            image,
        });
    }

    render() {
        const keys = keysFunction(
            this.props.default_image,
            this.country,
            this.props.id,
            this.props.onOpenAlertsModal,
        );
        return (
            <>
                <div className="secondary">
                    {this.is_one
                        ? this.props.data?.map((item) => (
                              <List
                                  className="table-main"
                                  key={item.id}
                                  loading={false}
                                  data={[item]}
                                  parent_id={this.props.parent_id}
                                  content_id={this.props.content_id}
                                  keys={keys}
                                  forceRun={this.forceRun}
                                  color={colors[1]}
                                  header={false}
                              />
                          ))
                        : this.props.data &&
                          this.props.data?.length > 1 && (
                              <>
                                  {/* {this.props.id && (
                                      <div className="d-flex justify-content-end py-10 pr-35">
                                          <button
                                              className="button button-filled button-primary"
                                              onClick={this.props.onOpenAlertsModal}
                                          >
                                              Get latest articles-alerts
                                          </button>
                                      </div>
                                  )} */}
                                  <DataTable
                                      nodes={this.props.data}
                                      sortFns={{}}
                                      searchFunction={(data) => data}
                                      COLUMNS={COLUMNS(this.country)}
                                      onlyTable
                                      forceRun={this.forceRun}
                                      hasSort={false}
                                      additionalStyles={{
                                          Table: `
                                                --data-table-library_grid-template-columns : minmax(100px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                                                ${scrollForTable}
                                            `,
                                          BaseCell: `  font-family: 'Raleway';
                                            font-weight: 500;
                                            font-size: 16px;
                                            line-height: 19px;
                                            padding: 16px 10px !important;
                                            color: #0D182C;
                                        
                                        
                                            &.underline {
                                                text-decoration: underline;
                                            }
                                            `,
                                      }}
                                  />
                              </>
                          )}
                </div>
            </>
        );
    }
}

export default Summary;
